import { withResourcePickerState } from '@kinet-open-network/client/shared/data-access/state';
import { signalStore } from '@ngrx/signals';
import { CustomersService } from '../services/customers.service';

export const CustomerPickerStore = signalStore(
  { protectedState: false }, withResourcePickerState(CustomersService, {
    label: 'fullname',
    value: 'id',
  }),
);
